import PressAndHold from '../../PressAndHold'

export const onTouchend = () => {
  PressAndHold.stopDetection()
}
